import React from 'react';
import { css } from 'aphrodite';
import styles from './user-menu-styles';
import { FaUndoAlt } from 'react-icons/fa';
import Switch from '../common/switch/switch';

const UserMenuView = (props) => (
  <div className={css(styles.root)}>

    {props.auth.admin && <div>
      <div className={css(styles.menuItemKiffgo, !!props.auth.business && styles.menuItemKiffgoHoverable)} onClick={props.viewAsAdmin}>
        <div>{!!props.auth.business ? 'Back to Kiffgo Admin' : 'Kiffgo Admin'}</div>
        <div style={{ flex: 1 }} />
        <FaUndoAlt className={css(styles.backToAdminIcon, !!props.auth.business && styles.backToAdminIconVisible)} />
      </div>

      {props.businessAccounts.list.map(business => (
        <div key={business.id} className={css(styles.menuItem)} onClick={() => props.toggleViewAsBusiness(business.id)}>
          <div>View as {business.name}</div>
          <div style={{ flex: 1 }} />
          <Switch checked={props.auth.business_id === business.id} onChange={() => {
          }} />
        </div>
      ))}
    </div>}

    <div className={css(styles.menuItem)} onClick={props.logout}>
      Logout
    </div>
  </div>
);

export default UserMenuView;



// WEBPACK FOOTER //
// ./src/components/sidebar/user-menu-view.js